import { ChartComponent } from '..'
import { TimeSeriesChart, createTimeSeries, createTimeSeriesLegendComponents } from './timeSeries'
import { Histogram, createHistogram, createHistogramLegendComponents } from './histogram'
import { LegendComponent } from '../../LegendBase'
import { BarChart, createBarChart } from './bar'
import { LineChart, createLineChart } from './lineChart'
import { LabelConfig } from '../../LegendBase/components/CheckboxComponent/CheckboxComponent.vue'
import { DataSource } from '@/composables/useDataSources'

export type ChartType = 'timeseries' | 'bar' | 'histogram' | 'line'

export type Chart<Type extends ChartType = ChartType> = Type extends 'timeseries'
  ? { type: 'timeseries' } & TimeSeriesChart
  : Type extends 'histogram'
  ? { type: 'histogram' } & Histogram
  : Type extends 'bar'
  ? { type: 'bar' } & BarChart
  : Type extends 'line'
  ? { type: 'line' } & LineChart
  : never

export function compileChart(
  chart: Chart,
  dataSources: Record<string, DataSource<any> | undefined>,
  viewport: { width: number; height: number },
  locale: string
): ChartComponent[] | undefined {
  if (chart.type === 'timeseries') {
    return createTimeSeries(chart, dataSources, viewport, locale)
  } else if (chart.type === 'histogram') {
    return createHistogram(chart, dataSources, viewport, locale)
  } else if (chart.type === 'bar') {
    return createBarChart(chart, dataSources, viewport, locale)
  } else if (chart.type === 'line') {
    return createLineChart(chart, dataSources, viewport, locale)
  }
}

export function filterChartComponents(
  type: ChartType,
  components: ChartComponent[],
  enabeledLabels: Set<string>
): ChartComponent[] {
  if (type === 'timeseries') {
    return components.filter((component) =>
      component.type === 'line' || component.type === 'highlight-circle'
        ? (component.label && enabeledLabels.has(component.label)) || !component.label
        : true
    )
  } else if (type === 'histogram') {
    return components.filter((component) =>
      component.type === 'line'
        ? (component.label && enabeledLabels.has(component.label)) || !component.label
        : true
    )
  } else {
    return components
  }
}

export function createChartLegendComponents(
  chart: Chart,
  locale: string,
  labelConfig?: LabelConfig
): LegendComponent[] {
  if (chart.type === 'timeseries') {
    return createTimeSeriesLegendComponents(chart, locale, labelConfig)
  } else if (chart.type === 'histogram') {
    return createHistogramLegendComponents(chart, locale)
  } else {
    return []
  }
}
